// extracted by mini-css-extract-plugin
export default {"root":"NeovarsityManagementPendingPage_root__0q8aH"};